export interface IUploadFile {
  file: File
  previewUrl: any | null
}

export class UploadedImages {
  images: string[] = []
  thumbs: string [] = []

  static from(images: string[] | null, thumbs: string[] | null): UploadedImages {
    let ui = new UploadedImages()
    if (images != null) {
      ui.images = images.filter(i => i != null)
    }
    if (thumbs != null) {
      ui.thumbs = thumbs.filter(i => i != null)
    }
    return ui
  }
}
